var joyride = (function() {
"use strict";

	var win  	= $(window),
		url 	= window.location.href,
		guide 	= $('#guide-tour'),
		field 	= 'ShowGuide';

	if(url.indexOf('?' + field + '=') !== -1) {
	    win.on('load', initAdminGuide);
	}

	function initAdminGuide() {
        guide.joyride({
         	autoStart : true,
        	modal: true,
        	expose: true,
        	template: {
        	    link: '<a href="#close" class="joyride-close-tip">' + SETTINGS.translations.endguidedtour + ' <span class="ss-navigateright"></span></a>'
        	}
        });
	}
})();